import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../../app/guards'
import { EditEmployeePage } from '../../../../../features/hr/edit-page'

export const Route = createFileRoute('/_app/hr/employees/$employeeId/edit')({
  staticData: { crumb: 'hrEmployeeEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'employees.manage'),
  component: EditEmployeePage,
})
